Ext.define('SA.data.scatterplot.ScatterPlotArgs', {
    singleton: true,

    from({cfg, data, isExport = false, isPartial, model, titleWidth}) {
        return {
            cfg,
            data,
            geographicUnit: model.getGeographicUnit(),
            isExport,
            isLineOfBestFitEnabled: model.isLineOfBestFitEnabled(),
            isPartial,
            location: model.getLocation(),
            pointColor: model.getPointColor(),
            pointRadius: model.getPointRadius(),
            projectAttributes: model.getProject().getAttributes().filter(id => model.supportsAttribute(id)),
            title: model.getTitle(),
            titleWidth,
            xAttribute: model.getXAttribute(),
            yAttribute: model.getYAttribute()
        };
    }
});